





















































import { Vue, Component } from 'vue-property-decorator'
import { date } from 'quasar'
import dateShort from 'src/assets/dateShort'
import icon from 'components/presenter/item/ItemIcon'
import PullAndScroll from 'components/PullAndScroll.vue'
import SignupButton from 'components/attendee/SignupButton.vue'
import SessionItem from 'components/presenter/layout/ActivityDashboardSessionItem.vue'
import ForumTopicItem from 'components/presenter/layout/ActivityDashboardForumTopicItem.vue'
import ContentSubitems from 'components/presenter/item/folder/ContentSubitems.vue'
import api from 'src/assets/api/gql'
import AttendeeIndex from 'src/graphql/attendee/AttendeeIndex.gql'
import AttendeeItemRecent from 'src/graphql/attendee_item/AttendeeItemRecent.gql'
import { Session, ForumTopic, AttendeeItem, ItemType } from 'src/graphql/types'

@Component({
  components: {
    PullAndScroll,
    SignupButton,
    SessionItem,
    ForumTopicItem,
    ContentSubitems
  }
})
export default class PageAttendeeIndex extends Vue {
  dateShort = dateShort
  icon = icon
  ItemType = ItemType
  formatDate = date.formatDate
  loading = false
  coming: Session[] = []
  topics: ForumTopic[] = []
  recent: AttendeeItem[] = []
  recentLoadCursor: string | null = null

  async refresh (done: () => void) {
    const { data: { attendeeComingSessions, attendeeForumTopicsRecent } } = await api.query({
      query: AttendeeIndex,
      variables: {
        days: 1,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        first: 3
      }
    })
    this.coming = attendeeComingSessions.nodes as Session[]
    this.topics = attendeeForumTopicsRecent.nodes as ForumTopic[]
    this.recent = []
    done()
  }

  async load (index: number, done: (stop?: boolean) => void) {
    const { data: { attendeeItemRecent } } = await api.query({
      query: AttendeeItemRecent,
      variables: {
        after: this.recentLoadCursor
      }
    })
    this.recent = attendeeItemRecent.nodes as AttendeeItem[]
    this.recentLoadCursor = attendeeItemRecent.pageInfo.hasNextPage ? attendeeItemRecent.pageInfo.endCursor : null
    done(!this.recentLoadCursor)
  }

  activitySessionUrl (session: Session) {
    return session.topic ? `/attendee/${session.topic.id}/session/${session.id}` : '/attendee/'
  }

  activityForumTopicUrl (forumTopic: ForumTopic) {
    return `/attendee/${forumTopic.courseId}/forum/${forumTopic.id}`
  }
}
